import React, { useContext, useEffect, useState } from 'react';
import Header from '../CommonComponents/Header';
import PublicProfileBasicInfo from './PublicProfileBasicInfo';
import PublicProfileProblemsLanguage from './PublicProfileProblemsLanguage';
import PublicProfileSkills from './PublicProfileSkills';
import CcHome from '../Student/CodingChallenge/CcHome';
import PublicHeatMap from './PublicHeatMap';
import { useParams } from 'react-router-dom';
import AlertContext from '../../context/AlertContext';
import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import constants from '../../constants';
import Loading from '../Notification-Loading/Loading/Loading';

// temporary defaults, will be replaced with API results
const defaultUser = {
  fullName: "Unknown User",
  picture: "",
  location: "India",
  college: "",
  rank: "-"
};

const PublicProfilePage = () => {
  const { setShowNotify, setIsLoaded, isLoaded } = useContext(AlertContext);
  const { idHash, username } = useParams();
  const axios = useAxiosPrivate();

  const isLoggedIn = !!localStorage.getItem("tokenKey");

  const [user, setUser] = useState(defaultUser);
  const [languages, setLanguages] = useState([]);
  const [skills, setSkills] = useState([]);
  const [validUser, setValidUser] = useState(false);
  const [loadingProfile, setLoadingProfile] = useState(false); // local loading state
  const [errorMsg, setErrorMsg] = useState("");
  const[publicprofile,setPublicProfile]=useState(null);
  // fetch profile and stats when idHash, username changes
  useEffect(() => {
    if (!idHash || !username) {
      setErrorMsg("Invalid profile URL");
      return;
    }

    const loadProfile = async () => {
      setLoadingProfile(true);
      setIsLoaded(true);
      setErrorMsg("");
      try {
        const res = await axios.get(`${process.env.REACT_APP_PUBLIC_PROFILE_BASE_URL}u/${idHash}/${username}`); // idHash works same as slug
        if (res.data?.resultCode === constants.RESULT_STATUS.SUCCESS) {
          // const p = res.data.profile;
          // const rankData = res.data.rank;
          // setUser({
          //   fullName: `${p.firstname || ""} ${p.lastname || ""}`.trim(),
          //   location: "India", // Placeholder, update when location data is available
          //   college: p.college || "",
          //   picture: p.picture || "",
          //   rank: rankData?.rank || "",
          // });

          // setValidUser(true);
          // setLanguages(res.data.languageStats || []);
          // setSkills(res.data.skillStats || []);
          setPublicProfile(res.data.body);
        } else {
          throw new Error(res.data?.msg || "Unknown error");
        }
      } catch (error) {
        console.error("Public profile fetch failed", error);
        setValidUser(false);
        const message =
          error.response?.status === 404
            ? "No user exists for this URL"
            : error.response?.status >= 500
            ? "Server error. Please try again later."
            : error.message || "Unable to load profile";
        setErrorMsg(message);
        setShowNotify({
          show: true,
          title: "Profile not found",
          msg: message,
        });
      } finally {
        setLoadingProfile(false);
        setIsLoaded(false);
      }
    };

    loadProfile();
  }, [idHash,username, axios, setIsLoaded, setShowNotify]);

  // display error or loader before showing actual profile
  if (!idHash ||!username || errorMsg) {
    return (
      <div className="public-profile-container">
        {!isLoggedIn && <Header />}
        <div className="public-profile-error">
          <h2>{errorMsg || "Invalid profile URL"}</h2>
          <p>Please check the link or return to the homepage.</p>
        </div>
      </div>
    );
  }

  if (loadingProfile) {
    return (
      <div className="public-profile-container">
        {!isLoggedIn && <Header />}
          <Loading />
      </div>
    );
  }

  return (
    <iframe
      srcDoc={publicprofile}
      title="Public Profile"
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
    // <div className='public-profile-page-container'>
    //   {!isLoggedIn && <Header />}

    //   {validUser && (

    //     <div className='public-profile-page-container-content'>
    //       <div className='public-profile-left-section'>
    //         <PublicProfileBasicInfo user={user} />
    //         <div className='scroll-content'>
    //           {languages.length > 0 && <hr />}
    //           {languages.length > 0 && <PublicProfileProblemsLanguage languages={languages} />}
    //           {skills.length > 0 && <hr />}
    //           {skills.length > 0 && <PublicProfileSkills skills={skills} />}
    //         </div>
    //       </div>

    //       {/* Main Content */}
    //       <div className='public-profile-right-section'>
    //         {/* <PublicProfileHeatMap /> */}
    //         <PublicHeatMap />
    //         <div className='publicProfileShareCC'>
    //           <CcHome />
    //         </div>
    //       </div>
    //     </div>
    //   )}
    // </div>
  )
}

export default PublicProfilePage;
 